<template>
  <div class="emat-block" :class="{'mobile': device === 'mobile'}">
    <slot name="pre-heading"></slot>
    <div class="emat-block-heading"
         :class="{'flex': hasExtraSlot, 'mobile': device === 'mobile', order: order, 'mobile-order': isMobileOrder}">
      <div class="discounted-container" v-if="discount">
        <div class="left">
          <span v-text="replacePrice(discount)"></span>
        </div>
      </div>
      <div v-else>
        <span v-text="name" :class="{'green': order}"></span>
        <span class="text" v-if="isMobileOrder">/st</span>
      </div>
      <span class="sub-title" v-if="subTitle" v-text="(subTitle).replace('.', ',')"></span>
      <div class="extra" v-if="hasExtraSlot">
        <!-- @slot Extra information in de header, aligned right -->
        <slot name="extra"></slot>
      </div>
    </div>
    <!-- @slot Fill this BlockItems -->
    <div class="emat-block-items">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import GreenCheckSvg from '../../../assets/icons/green-check.svg?inline';

export default {
  name: 'Block',
  props: {
    /**
     * Unique name for your input
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * The option to add text directly underneath the title {use as: [sub-title="title"]}
     */
    subTitle: {
      type: String,
      required: false,
    },
    /**
     * Boolean if order menu
     */
    order: {
      type: Boolean,
      required: false,
      default: false,
    },
    discount: {
      type: String,
      required: false,
    },
    discountAmount: {
      type: String,
      required: false,
    },
    device: {
      type: String,
      default: 'desktop',
    },
    isMobileOrder: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GreenCheckSvg,
  },
  computed: {
    hasExtraSlot() {
      return !!this.$slots['extra'];
    },
  },
  methods: {
    replacePrice(price) {
      price = parseFloat(price).toFixed(2);
      price = price.replace('.', ',');
      return price;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";
.emat-block {
  box-shadow: $box-shadow-small;
  background-color: #fff;
  margin-top: 25px;
  border-radius: $border-radius;

  &.mobile {
    box-shadow: none;
  }

  .emat-block-item {
    &:first-child {
      border-top: 1px solid #F1F1F3;
    }

    &:last-child {
      border-bottom-right-radius: $border-radius;
      border-bottom-left-radius: $border-radius;
    }
  }

  .emat-block-heading {
    @include header-font;
    color: var(--c-primary);
    padding: 20px 15px;
    line-height: 21px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: relative;
    width: 100%;
    box-sizing: border-box !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);

    &.order {
      padding: 10px 0 11px 13px;
    }

    &.mobile-order {
      font-size: 22px;
    }

    &.mobile {
      padding: 10px 8px;
      box-shadow: none;
    }

    .text {
      font-size: 12px;
      font-family: var(--font);
      color: $black;
    }

    .discounted-container {
      display: flex;
      flex-direction: row;
      margin-bottom: 6px;

      .left {
        @include header-font;
        display: flex;
        flex-direction: column;
        font-size: 22px;
      }

      .discounted {
        text-decoration: line-through;
        font-family: var(--font);
        color: #555555;
        font-size: 14px;
        font-weight: 900;
      }

      .discount-amount {
        text-align: center;
        display: flex;
        flex-direction: column;
        margin-left: auto;
        margin-top: -6px;
        margin-right: 25px;

        .text {
          display: block;
          font-size: 12px;
          color: #555555;
        }

        .discount-price {
          display: inline-block;
          width: fit-content;
          padding: 2px 6px;
          color: white;
          border-radius: 15px;
          font-size: 14px;
          background-color: var(--c-primary);
        }
      }
    }

    &.flex {
      flex-direction: row;
      padding: 20px 15px;
    }

    .green {
      color: #68B612;
      padding-left: 30px;
      max-width: 75%;
    }

    .icon {
      top: 35%;
      left: 10px;
      position: absolute;
    }
  }

  .sub-title {
    line-height: 14px;
    font-size: 12px;
    font-family: var(--font);
    color: black;
  }
}
</style>
